/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { destinationsList } from "../../funcs/destinationsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  tenantId: z.string(),
  type: operations.ListTenantDestinationsType$inboundSchema.optional(),
  topics: operations.Topics$inboundSchema.optional(),
};

export const tool$destinationsList: ToolDefinition<typeof args> = {
  name: "destinations-list",
  description: `List Destinations

Return a list of the destinations for the tenant. The endpoint is not paged.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await destinationsList(
      client,
      args.tenantId,
      args.type,
      args.topics,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
